const FOOTER_LOGO_SELECTOR = '[data-footer-logo-reveal]';
const REVEALED_CLASS = 'footer-utilities__footer-logo--revealed';
const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/**
 * @param {Element} element
 */
const revealLogo = (element) => {
  if (!(element instanceof HTMLElement)) return;
  element.classList.add(REVEALED_CLASS);
};

const initializeFooterLogoReveal = () => {
  const footerLogos = document.querySelectorAll(FOOTER_LOGO_SELECTOR);
  if (footerLogos.length === 0) return;

  if (prefersReducedMotion) {
    for (const footerLogo of footerLogos) {
      revealLogo(footerLogo);
    }
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;

        revealLogo(entry.target);
        observer.unobserve(entry.target);
      }
    },
    {
      threshold: 0.2,
      rootMargin: '0px 0px -5% 0px',
    }
  );

  for (const footerLogo of footerLogos) {
    if (footerLogo.classList.contains(REVEALED_CLASS)) continue;
    observer.observe(footerLogo);
  }
};

initializeFooterLogoReveal();

document.addEventListener('shopify:section:load', initializeFooterLogoReveal);
